module.exports = __webpack_public_path__ + "static/media/38.d5e391d7.png";